// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { PDFDocument, PDFTextField, PDFCheckBox, PDFDropdown, PDFRadioGroup } from 'pdf-lib';
import { getFieldLabel, getFieldSection } from '../form-definitions';

function extractFieldInfo(field, detectedType) {
  const name = field.getName();
  let type = 'unknown';
  if (field instanceof PDFTextField) type = 'PDFTextField';
  else if (field instanceof PDFCheckBox) type = 'PDFCheckBox';
  else if (field instanceof PDFDropdown) type = 'PDFDropdown';
  else if (field instanceof PDFRadioGroup) type = 'PDFRadioGroup';

  const info = {
    name,
    type,
    options: [],
    label: getFieldLabel(detectedType, name),
    section: getFieldSection(detectedType, name),
  };
  if (type === 'PDFTextField') {
    info.currentValue = field.getText() || '';
    info.isMultiline = field.isMultiline();
  } else if (type === 'PDFCheckBox') {
    info.currentValue = field.isChecked();
  } else if (type === 'PDFDropdown') {
    info.options = field.getOptions();
    info.currentValue = field.getSelected()?.[0] || '';
  } else if (type === 'PDFRadioGroup') {
    info.options = field.getOptions();
    info.currentValue = field.getSelected() || '';
  }
  return info;
}

export async function extractFieldsFromTemplate(templateBytes, detectedType) {
  const pdfDoc = await PDFDocument.load(templateBytes, { ignoreEncryption: true });
  const pdfForm = pdfDoc.getForm();
  return pdfForm.getFields().map(f => extractFieldInfo(f, detectedType));
}

export function buildInitialValues(fields, savedValues) {
  const hasSaved = Object.keys(savedValues).length > 0;
  const initVals = {};
  fields.forEach(f => {
    initVals[f.name] = hasSaved && savedValues[f.name] !== undefined
      ? savedValues[f.name]
      : f.currentValue ?? '';
  });
  return initVals;
}

export async function buildPreviewBytes(templateBytes, fields, initVals) {
  if (fields.length === 0) return templateBytes;
  try {
    const previewDoc = await PDFDocument.load(templateBytes, { ignoreEncryption: true });
    const previewForm = previewDoc.getForm();
    fields.forEach(f => {
      try {
        const val = initVals[f.name];
        if (f.type === 'PDFTextField') {
          previewForm.getTextField(f.name).setText(String(val || ''));
        } else if (f.type === 'PDFCheckBox') {
          const cb = previewForm.getCheckBox(f.name);
          if (val) cb.check();
          else cb.uncheck();
        }
      } catch (e) {
        console.debug(`Skip applying preview value for ${f.name}:`, e);
      }
    });
    try { previewForm.updateFieldAppearances(); }
    catch (e) { console.debug('updateFieldAppearances unavailable:', e); }
    return await previewDoc.save();
  } catch {
    return templateBytes;
  }
}
